module.exports = __webpack_public_path__ + "media/images/identity_icono_2-fc393d8b.jpg";